export default function GenderInput(props) {
    return (
        <>
            <label htmlFor="gender-input"><strong>Gender</strong></label>
            <select id="gender-input" name="gender" className="form-control" {...props}>
                <option value="" className="placeholder-option">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
                <option value="N/A">Prefer not to answer</option>
            </select>
        </>
    );
}